const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class BusinessReportingServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async generateReport({ filename, filter, corporationId, startDate, endDate, lang }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/reports?lang=${lang}`,
        method: 'POST',
        data: {
          filename, filter, corporationId, startDate, endDate,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getReportBookings({ filter, page = 0, maxPerPage = 10, corporationId, startDate, endDate, sort }) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/reports/bookings`, {
        params: { filter, page, maxPerPage, corporationId, startDate, endDate, sort },
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  BusinessReportingServiceConnector,
};
